import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const Outline_Shorthand = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">✍️ CSS Outline Shorthand</h1>

      {/* Intro */}
      <p className="tutorial-intro">
        The <code>outline</code> property is a shorthand for setting{" "}
        <strong>outline-width</strong>, <strong>outline-style</strong>, and{" "}
        <strong>outline-color</strong> in a single line.
      </p>

      {/* Syntax */}
      <div className="tutorial-section">
        <h2 className="section-title">Syntax</h2>
        <CodeCopyBlock
          code={`selector {
  outline: [outline-width] [outline-style] [outline-color];
}`}
        />
        <p>
          - <strong>outline-width</strong>: thickness of the outline (e.g.{" "}
          <code>thin</code>, <code>medium</code>, <code>5px</code>) <br />-{" "}
          <strong>outline-style</strong>: type of outline (e.g.{" "}
          <code>solid</code>, <code>dashed</code>, <code>dotted</code>) <br />-{" "}
          <strong>outline-color</strong>: any valid color value
        </p>
      </div>

      {/* Examples */}
      <div className="tutorial-section">
        <h2 className="section-title">Examples</h2>
        <CodeCopyBlock
          code={`p.example1 {
  outline: thin solid red;
}

p.example2 {
  outline: 3px dashed blue;
}

p.example3 {
  outline: thick dotted green;
}

p.example4 {
  outline: 5px double purple;
}`}
        />

        {/* Live Demos */}
        <p
          style={{
            border: "2px solid #333",
            outline: "thin solid red",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          Thin solid red outline
        </p>
        <p
          style={{
            border: "2px solid #333",
            outline: "3px dashed blue",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          3px dashed blue outline
        </p>
        <p
          style={{
            border: "2px solid #333",
            outline: "thick dotted green",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          Thick dotted green outline
        </p>
        <p
          style={{
            border: "2px solid #333",
            outline: "5px double purple",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          5px double purple outline
        </p>
      </div>

      {/* Description */}
      <div className="tutorial-section">
        <h2 className="section-title">Important Notes</h2>
        <ul className="tutorial-list">
          <li>
            You can omit one or two values—browser will use defaults for the
            missing parts.
          </li>
          <li>
            Default outline style is <code>none</code> (invisible).
          </li>
          <li>
            Outlines do not take up space and do not affect element size (unlike
            borders).
          </li>
        </ul>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">Next Steps</h2>
        <p>
          Now that you understand the <strong>outline shorthand</strong>, you
          can explore how it’s different from{" "}
          <a href="/css/borders" className="learn-more">
            CSS Borders
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default Outline_Shorthand;
